import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectConditionDO } from '../../../../../../system/system-dtos';
import { environment } from '../../../../../../../environments/environment';
import { ImageUtils } from '../../../../../../common/utils/image-utils';

@Component({
  selector: 'app-table-cell-card-panel',
  templateUrl: './card-panel-table-cell.component.html',
  styleUrls: ['./card-panel-table-cell.component.scss'],
  standalone: false,
})
export class CardPanelTableCellComponent extends DataTypeComponent implements OnDestroy, AfterViewInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  condition: SelectConditionDO;

  public imageSrc: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit() {
    if (this.data) {
      if (typeof this.data.cardLogo === 'string' && this.data.cardLogo.indexOf('./assets/') >= 0) {
        this.imageSrc = ImageUtils.relocateImage(this.data);
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  ngOnDestroy() {}
}
